enum IDB_TABLE {
  MESSAGES = 'messages',
}

class IndexDB {
  dbName = `DCC_widget_${window.DCC_CONFIG.ENVIRONMENT}`

  init(): Promise<void> {
    if (!('indexedDB' in window)) {
      console.error('This browser doesn\'t support IndexedDB.')
      return Promise.resolve()
    }

    if (!window.DCC_CONFIG.ENVIRONMENT) {
      console.error('No environment info on indexDB initialization.')
      return Promise.resolve()
    }

    const openRequest = indexedDB.open(this.dbName, 1)

    openRequest.onupgradeneeded = function (event) {
      const db = openRequest.result

      switch (event.oldVersion) {
        case 0: {
          db.createObjectStore(IDB_TABLE.MESSAGES, { keyPath: 'chatUID', autoIncrement: true })
          break
        }
      }
    }

    openRequest.onerror = () => {
      indexedDB.deleteDatabase(this.dbName)
      window.location.reload()
    }

    return new Promise(resolve => {
      openRequest.onsuccess = function () {
        resolve()
      }
    })
  }

  prepareObjectStore(object: IDB_TABLE): Promise<IDBObjectStore> {
    const openRequest = indexedDB.open(this.dbName)

    return new Promise(resolve => {
      openRequest.onsuccess = () => {
        const db = openRequest.result
        const transaction = db.transaction(object, 'readwrite')
        const objectStore = transaction.objectStore(object)

        resolve(objectStore)
      }
    })
  }

  async putMessages(messages: IMessageUnparsed[], chatUID: string): Promise<void> {
    const os = await this.prepareObjectStore(IDB_TABLE.MESSAGES)
    os.put({ chatUID, data: messages })
  }

  async getMessages(chatUID: string): Promise<IMessageUnparsed[]> {
    const os = await this.prepareObjectStore(IDB_TABLE.MESSAGES)
    const request: IDBRequest = os.get(chatUID)

    return new Promise(resolve => {
      request.onsuccess = () => {
        const result: IdbMessages | undefined = request.result
        const messages: IMessageUnparsed[] = result ? result.data : []

        resolve(messages)
      }
    })
  }

  async addMessage(message: IMessageUnparsed): Promise<void> {
    const os = await this.prepareObjectStore(IDB_TABLE.MESSAGES)
    const request: IDBRequest<IdbMessages> = os.get(message.chat_uid)

    request.onsuccess = () => {
      const result: IdbMessages | undefined = request.result
      const messages: IMessageUnparsed[] = result ? result.data : []

      os.put({ chatUID: message.chat_uid, data: [...messages, message] })
    }
  }

  async putMessage(message: IMessageUnparsed): Promise<void> {
    const os = await this.prepareObjectStore(IDB_TABLE.MESSAGES)
    const request: IDBRequest<IMessageUnparsed[]> = os.get(message.chat_uid)

    request.onsuccess = () => {
      os.put({
        chatUID: message.chat_uid,
        data: request.result.map(m => m.id === message.id ? message : m),
      })
    }
  }

  async deleteMessage(message: IMessageUnparsed): Promise<void> {
    const os = await this.prepareObjectStore(IDB_TABLE.MESSAGES)
    const request: IDBRequest<IMessageUnparsed[]> = os.get(message.chat_uid)

    request.onsuccess = () => {
      os.put({
        chatUID: message.chat_uid,
        data: request.result.filter(m => m.id !== message.id),
      })
    }
  }
}

export { IndexDB }